export default __webpack_public_path__ + "static/media/cplusplus.3b0d7340.svg";